import { Box, Stack, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { ReactNode } from "react";

import {
  settingsSectionHeadingSx,
  settingsSubmenuContentPl,
  settingsSubmenuPl
} from "~/features/settings/settings.styles";

type SettingsSectionWrapperProps = {
  id?: string;
  title: ReactNode;
  children: ReactNode;
  /** Vertical gap between section title and body */
  gap?: number;
};

export function SettingsSectionWrapper({
  id,
  title,
  children,
  gap = 1.5
}: SettingsSectionWrapperProps) {
  return (
    <Stack id={id} spacing={gap}>
      <Typography
        variant="subtitle1"
        component="h2"
        sx={
          [
            settingsSectionHeadingSx,
            {
              pl: settingsSubmenuPl,
              boxSizing: "border-box"
            }
          ] as SxProps<Theme>
        }
      >
        {title}
      </Typography>
      <Box
        sx={{
          pl: settingsSubmenuPl,
          minWidth: 0,
          boxSizing: "border-box"
        }}
      >
        <Box
          sx={{
            pl: settingsSubmenuContentPl,
            minWidth: 0,
            width: "100%",
            boxSizing: "border-box"
          }}
        >
          {children}
        </Box>
      </Box>
    </Stack>
  );
}

type SettingsSubsectionProps = {
  id?: string;
  title: ReactNode;
  children: ReactNode;
  gap?: number;
};

export function SettingsSubsection({
  id,
  title,
  children,
  gap = 1.25
}: SettingsSubsectionProps) {
  return (
    <Stack id={id} spacing={gap}>
      <Typography variant="subtitle2" sx={settingsSectionHeadingSx}>
        {title}
      </Typography>
      <Box
        sx={{
          pl: settingsSubmenuContentPl,
          minWidth: 0,
          width: "100%",
          boxSizing: "border-box"
        }}
      >
        {children}
      </Box>
    </Stack>
  );
}
